/* eslint-disable quote-props */
import { createHttpClient } from '../utils/httpUtils';

class RescheduleTaktService {
  constructor() {
    this.http = createHttpClient();
  }

  async show(rescheduleTaktId) {
    const res = await this.http
      .get('rescheduletakts/' + rescheduleTaktId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async destroy(rescheduleTaktId) {
    const res = await this.http
      .delete('rescheduletakts/' + rescheduleTaktId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async create(data) {
    const res = await this.http.post('rescheduletakts', data).catch((error) => {
      console.log(error.response);
      return false;
    });
    return res ? res.data : res;
  }

  async update(data) {
    const res = await this.http
      .put('rescheduletakts/' + data.id, data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async saveReSchedule(reSchedule) {
    const res = await this.http
      .post('rescheduletakts/apply', reSchedule)
      .catch((error) => false);
    return res ? res.data : res;
  }

  async getRescheduleBySector(sectorId) {
    const res = await this.http
      .post('rescheduletakts/bysector', {
        sectorId
      })
      .catch((error) => false);
    return res ? res.data : res;
  }
}

export const rescheduleTaktService = new RescheduleTaktService();
